import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ITaxDocNotifierJwt, JwtService, TaxDocNotifierClaim } from './jwt.service';

export interface IUser {
  name: string;
  claims: TaxDocNotifierClaim[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private userBehavior: BehaviorSubject<IUser | null> = new BehaviorSubject(null);

  constructor(private jwtService: JwtService) { }

  public login(): Observable<IUser> {
    return this.jwtService.getToken().pipe(
      map(jwt => this.mapJwtToUser(jwt)),
      tap(user => this.userBehavior.next(user))
    );
  }

  public logout(): void {
    this.userBehavior.next(null);
  }

  public getUser(): Observable<IUser> {
    return this.userBehavior.asObservable();
  }

  private mapJwtToUser(jwt: ITaxDocNotifierJwt): IUser {
    const claims: TaxDocNotifierClaim[] = [];

    Object.keys(TaxDocNotifierClaim).map(claimKey => {
      const claimName = TaxDocNotifierClaim[claimKey];
      if (jwt[claimName]) {
        claims.push(claimName);
      }
    });

    return {
      name: jwt.sub.toLocaleLowerCase().replace('us\\', ''),
      claims: claims
    };
  }
}
